module.exports = __webpack_public_path__ + "static/media/admin.92989b3f.jpg";